import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { createSlice } from "@reduxjs/toolkit";

const _initialState = {
  selectedServicesIds: [],
};

const serviceManagementSlice = createSlice({
  name: "serviceManagementSlice",
  initialState: _initialState,
  reducers: {
    setSelectServicesIds: (state, action) => {
      state.selectedServicesIds = action.payload;
    },
  },
});

export default serviceManagementSlice;
export const { name, reducer, actions } = serviceManagementSlice;

export const doUploadImgService = createAsyncThunk(
  "uploadImgService/upload",
  async ({ url, file, type }) => {
    try {
      const response = await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": type,
        },
        body: file,
      });
      if (response.ok) {
        return response.url;
      } else {
        toast.error(
          "Errore durante il caricamento del file su Azure Blob Storage"
        );
      }
    } catch (error) {
      toast.error(error.message);
      throw new Error(error.message);
    }
  }
);
